import { useMutation, useQueryClient } from '@tanstack/react-query';
import { requestItemSync } from '@/lib/api/work-integrations/itemSyncStatus';

export const useRequestItemSyncMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, integrationId }: { itemId: number; integrationId?: number }) =>
      requestItemSync({ itemId, integrationId }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['workIntegrations', 'itemSyncStatuses'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['workIntegrations', 'items'],
        }),
      ]);
    },
  });
};
